<template>
    <div class="group-news">
        <header-child></header-child>
        <!-- <list-content @update="goDetail" :listData="dataList"></list-content> -->
            <van-list
                v-model="isUpLoading"
                :finished="upFinished"
                finished-text="没有更多了"
                @load="onLoad"
                :offset="offset"
                >
                <div class="ul-box">
                <div class="li-box clearfix" v-for="(item, index) of dataList" :key="index" @click="goDetail(item.id,item.class)">
                    <div class="img-left fl">
                        <img v-lazy="item.img" alt="" class="img-responsive">
                    </div>
                    <div class="img-right fr">
                        <p class="title txt_limit2">{{item.title}}</p>
                        <div class="describe">
                            <span class="fl fs12 color-gray time">{{formatTime.getMsecToSpecificTime(item.addtime,'yyyy/MM/dd hh:mm:ss')}}</span>
                            <div class="fr class_name" :style="{color:item.color, border:'1px solid '+item.color+''}">{{item.class}}</div>
                        </div>
                    </div>
                </div>  
            </div>
            </van-list>
    </div>
</template>
<script>
import Vue from 'vue'
import HeaderChild from '@/components/HeaderChild'
import ListContent from '@/components/ListContent'
import { List ,Lazyload } from 'vant';

// options 为可选参数，无则不传
Vue.use(Lazyload,{
  preLoad: 1.3,
  error: '../../static/default.png',
  loading: '../../static/loding.png',
  attempt: 1
});

export default {
    props: {
        
    },
    components: {
        HeaderChild,
        ListContent,
        [List.name]:List
    },
    data() {
        return {
            tagColor:'FF943D',
            page: 0,//重新获取的当前的页码
            alltotal:0,//总的数据
            pageSize:8,//每一条的页数是10
            dataList:[],
            isUpLoading:false,//上拉加载
            upFinished:false,//上拉加载完毕
            offset:100,//滚动条与底部距离小于 offset 时触发load事件
        };
    },
    created() {
       
    },
    mounted() {
        
    },
    watch: {},
    methods: {
        onLoad(){ 
            //let self = this;
            setTimeout(() => {
                this.$axios.post(this.api.dynamic.list,{
                    page:this.page+1,
                    page_size:this.pageSize
                },res =>{
                    this.dataList=this.dataList.concat(res.data);
                    this.alltotal=Number(res.pageInfo.totalCount);
                    this.isUpLoading = false;
                    this.page++;
                    if (this.dataList.length >= this.alltotal) {
                        this.upFinished = true;
                    }
                },err =>{
                    this.dataList=[];
                });
            }, 500);
           
        },
        getList() {
            //tab切换
            this.$axios.post(this.api.dynamic.list,{
                page:this.page,
                page_size:this.pageSize
            },res =>{
                this.dataList=res.data;
                this.alltotal=Number(res.pageInfo.totalCount);
            },err =>{
                this.dataList=[];
            });
        },
        goDetail:function(id,name){
            this.$router.push('/dynamicDetail/'+id+'/'+name+'.html');
        },
    }
};
</script>
<style scoped lang="less">
.ul-box{
    width:100%;
    padding:16px;
    .li-box{
        height:80px;
        padding:8px;
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);
        border-radius:6px;
        margin-bottom:8px;
        .img-left{
            width:80px;
            height:60px;
        }
        .img-right{
            width:239px;
            height:60px;
            font-size:15px;
            color:#333;
            .title{
                height:42px;
                margin-bottom:2px;
            }
            .time{
                height:17px;
                line-height:17px;
            }
            .class_name:empty{padding:0;border:none;}
            
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/group/index.vue